import axios from 'axios';
import { buildApiUrl } from '../config/api';

export const RegionService = {
  fetchRegiones: async (token) => {
    try {
      const response = await axios.get(buildApiUrl('/api/locations/regiones'), {
        headers: { Authorization: `Bearer ${token}` },
      });

      return response.data || [];
    } catch (error) {
      console.error('Error en RegionService.fetchRegiones:', error);
      throw error;
    }
  },
};
